const topics = [
  { 
    title: "Force", standardNumber: "3-PS2-1", slug: "force",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fforce.mp4?alt=media&token=d90d58e8-21a5-403e-9cb9-4d065fb9c655 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fforce2025song.mp3?alt=media&token=aeed54c4-234a-4568-800a-a2b8ab0c9b11 ",
    lyrics: ["(Chorus)",
  "If you give a push or give a pull,",
  "That is force to an object.",
  "If you give a push or give a pull,",
  "That is force to an object.",
  
  "(Verse)",
  "Force is a push or a pull that will,",
  "Make an object stop.",
  "Force is a push or a pull that will,",
  "Change an object's speed.",
  "Force is a push or a pull that will,",
  "Change an object's direction.",
  "Force is a push or a pull that will,",
  "Change an object's direction.",
  
  "(Chorus)",
  "If you give a push or give a pull,",
  "That is force to an object.",
  "If you give a push or give a pull,",
  "That is force to an object.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Friction", standardNumber: "3-PS2-1", slug: "friction",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffriction2025song.mp3?alt=media&token=38d656a0-f811-4c14-98f3-c7f744ccaa75 ",
    lyrics: ["(chorus)",
  "The resistance to motion is friction.",
  "The resistance to motion is friction.",
  
  "(verse)",
  "Made by two objects moving against each other, each other.",
  "Made by two objects moving against each other, each other.",
  "Friction creates heat.",
  "Friction creates heat.",
  "When you rub your hands together",
  "you cause a resistance to motion,",
  "then you feel heat from friction, from friction.",
  
  "(chorus)",
  "The resistance to motion is friction.",
  "The resistance to motion is friction.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Motion", standardNumber: "3-PS2-2", slug: "motion",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmotion2025video.mp4?alt=media&token=90933e74-b520-41d9-8d19-f01f4a9a2204 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230 ",
    lyrics: ["(Chorus)",
  "If an object changes its position,",
  "Then a motion has occurred.",
  "If it continuously changes its position,",
  "Then it's in motion, then it's in motion.",
  
  "(Verse)",
  "Use a car as an example, and the car is parked at the curb.",
  "Now, you move the car up 10 feet, then a motion has occurred.",
  "Now, if you take the same parked car and put it on the highway,",
  "Then start coasting.",
  "Its position is constantly changing.",
  "Then, it's in motion, then it's in motion.",
  
  "(Chorus)",
  "If an object changes its position,",
  "Then a motion has occurred.",
  "If it continuously changes its position,",
  "Then it's in motion, then it's in motion.",
  "If an object changes its position,",
  "Then a motion has occurred.",
  "If it continuously changes its position,",
  "Then it's in motion, then it's in motion.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Charge It Up", standardNumber: "3-PS2-3", slug: "chargeitup",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fchargeitup2025song.mp3?alt=media&token=10a29cc4-9110-436a-8310-e4e5fa2eb7c8 ",
    lyrics: ["(Chorus)",
  "Electric forces, electric forces.",
  "Charge it up, charge it up.",
  "Electric forces, electric forces.",
  "Charge it up, charge it up.",
  "Like charges repel, unlike attract,",
  "Electric forces make objects act!",
  "Charge it up, charge it up.",
  
  "(Verse 1)",
  "Rub a balloon, give it a try,",
  "Stick it to the wall, watch it fly!",
  "Static builds, the charges appear,",
  "Electric forces are crystal clear!",
  "Lightning strikes, a zap so bright,",
  "Electric discharge in the night.",
  "Objects can move with a little rub.",
  "Charge it up, charge it up.",
  
  "(Chorus)",
  "Electric forces, electric forces.",
  "Charge it up, charge it up.",
  "Electric forces, electric forces.",
  "Charge it up, charge it up.",
  "Like charges repel, unlike attract,",
  "Electric forces make objects act!",
  "Charge it up, charge it up.",
  
  "(Verse 2)",
  "Test the charges, here’s what to do,",
  "See if they pull or push from you.",
  "If they repel, the charges are the same,",
  "If they attract, opposite’s the name!",
  "Test the charges, here’s what to do,",
  "See if they pull or push from you.",
  "If they repel, the charges are the same,",
  "If they attract, opposite’s the name!",
  
  "(Chorus)",
  "Electric forces, electric forces.",
  "Charge it up, charge it up.",
  "Electric forces, electric forces.",
  "Charge it up, charge it up.",
  "Like charges repel, unlike attract,",
  "Electric forces make objects act!",
  "Charge it up, charge it up.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Static Electricity", standardNumber: "3-PS2-3", slug: "staticelectricity",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fstaticelectricity2025song.mp3?alt=media&token=8c4c7f67-a28c-4bd1-bd3f-b47ec4c49ae7 ",
    lyrics: ["(chorus)",
  "Opposite charges attract each other.",
  "The same charges repel each other.",
  "When charges are imbalanced",
  "they can make electricity static.",
  
  "(verse)",
  "Some electrons from object A can rub off into object B.",
  "Losing electrons gives object A, a positive charge.",
  "Static electricity.",
  "Some electrons from object A can rub off into object B.",
  "Extra electrons give object B, a positive charge.",
  "Static electricity.",
  
  "(chorus)",
  "Opposite charges attract each other.",
  "The same charges repel each other.",
  "When charges are imbalanced",
  "they can make electricity static.",
  
  "(verse)",
  "Some electrons from object A can rub off into object B.",
  "Losing electrons gives object A, a positive charge.",
  "Static electricity.",
  "Some electrons from object A can rub off into object B.",
  "Extra electrons give object B, a positive charge.",
  "Static electricity.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Magnetism", standardNumber: "3-PS2-3", slug: "magnetism",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmagnetism2025song.mp3?alt=media&token=b44a43a4-31a3-4eac-b123-76d182b4794d ",
    lyrics: ["(chorus)",
  "Like charges repel, push away",
  "opposite charges attract, come together",
  "Certain metals are magnetic, are magnetic",
  "Certain metals are magnetic, are magnetic",
  
  "(verse)",
  "Magnetic poles, the strongest point of a magnet",
  "North and south, north and south",
  "Magnetic field is the force from the poles of a magnet",
  "Magnetic field, magnetic field",
  "Electromagnet is made by wrapping a wire around certain metals,",
  "around certain metals",
  "Electromagnet is not a permanent magnet,",
  "not a permanent magnet",
  
  "(chorus)",
  "Like charges repel, push away",
  "opposite charges attract, come together",
  "Certain metals are magnetic, are magnetic",
  "Certain metals are magnetic, are magnetic",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "The Magic of Magnets", standardNumber: "3-PS2-3", slug: "themagicofmagnets",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthemagicofmagnets2025song.mp3?alt=media&token=6e1b89fd-f033-4760-8d31-049393533d52 ",
    lyrics: ["(Chorus)",
  "Push or pull, what can we do?",
  "Magnets move things, it’s true!",
  "Close or far, they have the power,",
  "Magnets amaze us every hour!",
  
  "(Verse 1)",
  "When magnets pull, they bring things near,",
  "Metal moves close, it’s oh so clear.",
  "A force you can’t see, but it’s strong and true,",
  "Magnets are magic for me and you!",
  "If magnets push, the objects go,",
  "They move away, fast or slow.",
  "No need to touch, it’s a force unseen,",
  "Magnets are cool, they’re like a dream!",
  
  "(Chorus)",
  "Push or pull, what can we do?",
  "Magnets move things, it’s true!",
  "Close or far, they have the power,",
  "Magnets amaze us every hour!",
  
  "(Verse 2)",
  "North and south, they play their part,",
  "Attracting or repelling, they’re really smart.",
  "At a distance or close, the motion’s clear,",
  "Magnets show forces we can all cheer!",
  "With a push or a pull, objects move,",
  "Magnets make motion, they always prove.",
  "Experiment, learn, and you’ll see,",
  "Magnets are science and fun for me!",
  
  "(Chorus)",
  "Push or pull, what can we do?",
  "Magnets move things, it’s true!",
  "Close or far, they have the power,",
  "Magnets amaze us every hour!",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Magnets", standardNumber: "3-PS2-3", slug: "magnets",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Electromagnetic", standardNumber: "3-PS2-4", slug: "electromagnetic",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Animal Life Cycles", standardNumber: "3-LS1-1", slug: "animallifecycles",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fanimallifecycle2025video.mp4?alt=media&token=a5f4b0b0-5ca0-436f-8d09-0b25bc2cc186 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fanimallifecycle2025song%20.mp3?alt=media&token=666e6c14-f00a-4379-95cc-3047adb2ac18 ",
    lyrics: ["(Chorus)",
  "Born, developing, reproducing.",
  "Life cycle of animals.",
  "Born, developing, reproducing.",
  "Life cycle of animals.",
  
  "(Verse)",
  "Now, all animal life cycles are the same in some ways.",
  "We’re all born, we develop, we reproduce, then the cycle starts over again.",
  "Humans start reproducing from an egg inside a mother's body,",
  "For 9 months then they’re born, learning for 3 years as babies.",
  "Then we grow into children, taller, smarter, more independent.",
  "Around the ages 13 to 18, we’re teenagers, adolescents.",
  "After that, we become adults until we are old and grey.",
  "Start a family, when we reproduce the life cycle starts over again.",
  
  "(Chorus)",
  "Born, developing, reproducing.",
  "Life cycle of animals.",
  "Born, developing, reproducing.",
  "Life cycle of animals.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Plant Life Cycle", standardNumber: "3-LS1-1", slug: "plantlifecycle",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fplantlifecycle.mp4?alt=media&token=04c5304e-ef30-4fec-b739-882b2fd418ab ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplantlifecycle.mp3?alt=media&token=20abb63d-b1eb-4ab8-b653-4bd0e6bffc81 ",
    lyrics: ["(chorus)",
  "Plant life cycle, oh-wo-wo- oh -wo-wo.,",
  "Plant life cycle, oh-wo-wo- oh -wo-wo.,",
  "Plant life cycle, oh-wo-wo- oh -wo-wo.,",
  "Plant life cycle, oh-wo-wo- oh -wo-wo.,",
  
  "(verse)",
  "Now, all plant seeds have an outer cover called a seed coat,",
  "to protect the plant inside the seed called the embryo.,",
  "When the seed germinates, the root bust out then start growing down.,",
  "Then the seed germinates, the shoot bust out, grows up above the ground.,",
  "Now it’s a sprout right there.,",
  "With help from the water, soil, sun, and air,",
  "the plant becomes a seedling.,",
  "A small plant with a few leaves.,",
  "The next stage is a young adult plant.,",
  "Over time it becomes a full adult plant.,",
  "Then you’ll see the flowers or spores,",
  "used to reproduce and make more,,",
  "and make more,,",
  "through pollination.,",
  
  "(chorus)",
  "Plant life cycle, oh-wo-wo- oh -wo-wo.,",
  "Plant life cycle, oh-wo-wo- oh -wo-wo.,",
  "Plant life cycle, oh-wo-wo- oh -wo-wo.,",
  "Plant life cycle, oh-wo-wo- oh -wo-wo.,",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Metamorphosis", standardNumber: "3-LS1-1", slug: "metamorphosis",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmetamorphosis2025video.mp4?alt=media&token=089e2f87-60f3-45f8-a0bc-c404fa20a32d ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmetamorphosis2025song.mp3?alt=media&token=66998bf3-9960-4e1d-b273-f8b3dce186a6 ",
    lyrics: ["(chorus)",
  "Metamorphosis is the process",
  "An animal takes when it changes shapes.",
  "Metamorphosis is the process",
  "An animal takes when it changes shapes.",
  
  "(verse)",
  "Let’s look at a frog when it’s born,",
  "The eggs hatch and the tadpole comes on.",
  "The tadpoles live in the pond",
  "With a tail, no legs, no arms.",
  "Then after a while the legs start to form.",
  "The tail starts to shrink till it’s all gone.",
  "The eyes bulge out, the lungs finish developing.",
  "Now living on land, the frog is here.",
  
  "(chorus)",
  "Metamorphosis is the process",
  "An animal takes when it changes shapes.",
  "Metamorphosis is the process",
  "An animal takes when it changes shapes.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Life Cycles", standardNumber: "3-LS1-1", slug: "lifecycles",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Flifecycles2025song.mp3?alt=media&token=b0ad1abe-875f-4933-953a-8d4b57f2da06 ",
    lyrics: ["(chorus)",
  "Life cycles, round and round,",
  "Stages of life where changes are found.",
  "Butterflies and frogs, let’s compare,",
  "Their journeys are different, but life is shared!",
  
  "(verse)",
  "A butterfly starts with a tiny egg,",
  "Out comes a larva on little legs.",
  "It eats and grows, then spins a home,",
  "A pupa it’s called, where changes are shown.",
  "A frog lays eggs in the water’s flow,",
  "Out comes a tadpole, swimming below.",
  "With gills and a tail, it wiggles and grows,",
  "Then legs appear, as the tail goes!",
  
  "(chorus)",
  "Life cycles, round and round,",
  "Stages of life where changes are found.",
  "Butterflies and frogs, let’s compare,",
  "Their journeys are different, but life is shared!",
  
  "(verse)",
  "Butterflies change in four cool stages,",
  "Egg to larva, pupa to adult ages.",
  "Frogs have three steps, but that’s okay,",
  "Both grow and change in their own way!",
  "Life cycles, round and round,",
  "Stages of life where changes are found.",
  "Butterflies and frogs, let’s compare,",
  "Their journeys are different, but life is shared!",
  
  "(verse)",
  "Some have more stages, some have less,",
  "Each life cycle is nature’s best.",
  "From eggs to adults, their stories shine,",
  "Life cycles are amazing, every time!",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Germinating", standardNumber: "3-LS1-1", slug: "germinating",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Ecosystem Levels", standardNumber: "3-LS2-1", slug: "ecosystemlevels",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fecosystemlevels2025video.mp4?alt=media&token=d28fd355-34df-4108-aa08-aab6454be863 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fecosystemlevels2025song.mp3?alt=media&token=936d0836-5ca7-4b69-bb1c-04b8c39d689b ",
    lyrics: ["(chorus)",
  "There's levels or organization in every ecosystem.",
  "There's levels or organization in every ecosystem.",
  "You’ve got the organism, you’ve got the population, got the community, got the ecosystem.",
  "You’ve got the organism, you’ve got the population, got the community, got the ecosystem.",
  
  "(verse)",
  "Let's start with a single organism and call it level one.",
  "When that organism reproduce, and they reproduce, population has begun.",
  "Now, organisms interact with different organisms, it's a community.",
  "To make it an ecosystem, add the living things with the non-living things.",
  
  "(chorus)",
  "There's levels or organization in every ecosystem.",
  "There's levels or organization in every ecosystem.",
  "You’ve got the organism, you’ve got the population, got the community, got the ecosystem.",
  "You’ve got the organism, you’ve got the population, got the community, got the ecosystem.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Adaptation", standardNumber: "3-LS2-1", slug: "adaptation",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fadaptation2025video.mp4?alt=media&token=38306b56-b3b8-4d35-9d62-460a899023b4 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fadaptation2025song.mp3?alt=media&token=dc122dec-b0b5-4656-82c2-8e1c2297489b ",
    lyrics: ["(Chorus)",
  "What is adaptation? The way plants and animals learn to survive.",
  "What is adaptation? How they live in their habitat or environment.",
  "We adapt, we adapt,",
  "To our habitat, to our habitat.",
  
  "(Verse 1)",
  "There are some places on Earth that’s very cold or very hot,",
  "And still plants and animals live there, they’ve adapted to being there.",
  "Some places on Earth have lots of water or lots of rocks,",
  "And still plants and animals live there, they’ve adapted to being there.",
  "Let’s take a place that doesn’t have much water.",
  "Plants and animals both know how to conserve water, store that water.",
  "Let’s take a place with high temperatures.",
  "Plants move their leaves to minimize surface area hit by the sun.",
  "In a place with high temperatures,",
  "They both reduce heat output and animals use the shade to avoid the sun.",
  
  "(Chorus)",
  "What is adaptation? The way plants and animals learn to survive.",
  "What is adaptation? How they live in their habitat or environment.",
  "We adapt, we adapt,",
  "To our habitat, to our habitat.",
  
  "(Verse 2)",
  "Some animals camouflage, change their color or pattern to blend in.",
  "Some animals’ mimicry, change their whole look to look like something different.",
  "Some plants have needles, to cause pain feelings in animals that touch it.",
  "Some plants are poison, to harm an enemy that tries to eat it.",
  
  "(Chorus)",
  "What is adaptation? The way plants and animals learn to survive.",
  "What is adaptation? How they live in their habitat or environment.",
  "We adapt, we adapt,",
  "To our habitat, to our habitat.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Offspring ", standardNumber: "3-LS3-1", slug: "offspring",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Foffspring2025song.mp3?alt=media&token=cd9d4279-1bec-4d21-9904-e09aa0beb4c6 ",
    lyrics: ["(chorus)",
  "Offspring are alike, but not the same,",
  "Different colors, shapes, or names!",
  "From parents, they come, with traits to share,",
  "But each one is special, beyond compare!",
  
  "(verse)",
  "Kittens from a mama cat, fluffy and sweet,",
  "Some are orange, some black, a mix that’s neat.",
  "Puppies from the same mom can all look new,",
  "With spots or stripes, and colors too!",
  "Baby birds in a nest, they chirp and sing,",
  "Some have feathers with a shiny wing.",
  "Plants grow seeds, they sprout and bloom,",
  "Each flower’s color can fill the room!",
  
  "(chorus)",
  "Offspring are alike, but not the same,",
  "Different colors, shapes, or names!",
  "From parents, they come, with traits to share,",
  "But each one is special, beyond compare!",
  
  "(verse)",
  "Parents pass traits, like eyes or hair,",
  "But changes happen here and there.",
  "Variation makes nature bright,",
  "No two are the same, it’s a wonderful sight!",
  "So look around and you will see,",
  "Offspring are full of variety!",
  "From animals to plants, they’re all unique,",
  "Nature’s creations are quite the treat!",
  "(chorus)",
  "Offspring are alike, but not the same,",
  "Different colors, shapes, or names!",
  "From parents, they come, with traits to share,",
  "But each one is special, beyond compare!",
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Inherited", standardNumber: "", slug: "inherited",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Finherited2025video.mp4?alt=media&token=91e47b15-2c11-480d-87d0-ce23342bd813 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Finherited2025song.mp3?alt=media&token=0618f70d-a9ce-4a81-b04c-39e9dcaa6ef6 ",
    lyrics: ["(Chorus)",
  "When animals are born,",
  "There are a lot of different features that they will take on.",
  "Some are inherited, some are inherited.",
  "When plants are born,",
  "There are a lot of different features that they will take on.",
  "Some are inherited, some are inherited.",
  
  "(Verse)",
  "Now, animals can inherit some features from their parents,",
  "Like the color of their hair or the color of their eyes.",
  "Animals can inherit some features from their parents,",
  "Like the complexion of their skin or even their height.",
  "Plants too, can inherit from their parents",
  "Their color, their size, and shape.",
  "When genes are passed down from your parents,",
  "Different features you take.",
  
  "(Chorus)",
  "When animals are born,",
  "There are a lot of different features that they will take on.",
  "Some are inherited, some are inherited.",
  "When plants are born,",
  "There are a lot of different features that they will take on.",
  "Some are inherited, some are inherited.",
  
  "(Verse)",
  "Now, animals can inherit some features from their parents,",
  "Like the color of their hair or the color of their eyes.",
  "Animals can inherit some features from their parents,",
  "Like the complexion of their skin or even their height.",
  "Plants too, can inherit from their parents",
  "Their color, their size, and shape.",
  "When genes are passed down from your parents,",
  "Different features you take.",
  
  "(Chorus)",
  "When animals are born,",
  "There are a lot of different features that they will take on.",
  "Some are inherited, some are inherited.",
  "When plants are born,",
  "There are a lot of different features that they will take on.",
  "Some are inherited, some are inherited.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Traits", standardNumber: "3-LS3-2", slug: "traits",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Fossils", standardNumber: "3-LS4-1", slug: "fossils",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Fossils Tell A Story", standardNumber: "3-LS4-1", slug: "fossilstellastory",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Adapt to Survive", standardNumber: "3-LS4-2", slug: "adapttosurvive",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fadapttosurvivie2025video.mp4?alt=media&token=d7a55d38-6f01-48b5-842d-37634069c361 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fadapttosurvive2025song.mp3?alt=media&token=118906ed-f2bd-4a02-ae36-c519e8166ed8 ",
    lyrics: ["(Chorus)",
  "With changes in the world, every day,",
  "We adapt to survive, adapt to survive.",
  "With changes in the world, it’s nature’s way.",
  "We adapt to survive, adapt to survive.",
  "With changes in the world, every day,",
  "We adapt to survive, adapt to survive.",
  "Some plants and animals have special traits,",
  "To adapt to survive, adapt to survive.",
  
  "(Verse 1)",
  "A plant with thorns keeps danger away,",
  "While other plants get eaten, every day.",
  "Camouflage helps an animal hide,",
  "Safe from danger, it stays alive.",
  "Spots or stripes can blend right in,",
  "Hiding from predators, so they can win.",
  "In a changing world, traits play a role,",
  "Helping animals reach their goal.",
  
  "(Chorus)",
  "With changes in the world, every day,",
  "We adapt to survive, adapt to survive.",
  "With changes in the world, it’s nature’s way.",
  "We adapt to survive, adapt to survive.",
  "With changes in the world, every day,",
  "We adapt to survive, adapt to survive.",
  "Some plants and animals have special traits,",
  "To adapt to survive, adapt to survive.",
  
  "(Verse 2)",
  "Cause and effect, it’s easy to see,",
  "Traits help some live and set them free.",
  "Reproducing stronger, they’ll stay alive,",
  "Passing on traits, so life will thrive.",
  "So watch the world, it’s clear and true,",
  "Survival depends on what they do.",
  "Traits that help, they carry on,",
  "The cycle of life will keep moving strong!",
  
  "(Chorus)",
  "With changes in the world, every day,",
  "We adapt to survive, adapt to survive.",
  "With changes in the world, it’s nature’s way.",
  "We adapt to survive, adapt to survive.",
  "With changes in the world, every day,",
  "We adapt to survive, adapt to survive.",
  "Some plants and animals have special traits,",
  "To adapt to survive, adapt to survive.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Adaptive Characteristics", standardNumber: "3-LS4-2", slug: "adaptivecharacteristics",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fadaptivecharacteristics2025video.mp4?alt=media&token=8bef488a-f405-4403-bf1d-b2befa2d032d ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fadaptivecharacteristics2025video.mp4?alt=media&token=8bef488a-f405-4403-bf1d-b2befa2d032d ",
    lyrics: ["(chorus)",
  "Let’s analyze and describe some adaptive characteristics",
  "up in the ecosystem.",
  "Let’s analyze and describe some adaptive characteristics",
  "up in the ecosystem.",
  
  "(verse)",
  "Some animals have webbed feet just like an otter.",
  "They can search for food in the water, it makes them swim better.",
  "Some animals have sharp claws, like meat eaters,",
  "and they use those claws for killing their prey.",
  "Some use them for digging for food or shelter, hay.",
  "Some animals have large beaks, it helps some animals eat.",
  "Some animals have large teeth, it helps the animals eat.",
  "Some animals have large beaks, it helps some animals eat.",
  
  "(chorus)",
  "Let’s analyze and describe some adaptive characteristics",
  "up in the ecosystem.",
  "Let’s analyze and describe some adaptive characteristics",
  "up in the ecosystem.",
  
  "(verse)",
  "Some animals have webbed feet just like an otter.",
  "They can search for food in the water, it makes them swim better.",
  "Some animals have sharp claws, like meat eaters,",
  "and they use those claws for killing their prey.",
  "Some use them for digging for food or shelter, hay.",
  "Some animals have large beaks, it helps some animals eat.",
  "Some animals have large teeth, it helps the animals eat.",
  "Some animals have large beaks, it helps some animals eat.",
  
  "(chorus)",
  "Let’s analyze and describe some adaptive characteristics",
  "up in the ecosystem.",
  "Let’s analyze and describe some adaptive characteristics",
  "up in the ecosystem.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Predator & Prey", standardNumber: "3-LS4-2", slug: "predatorprey",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fpredatorandprey2025song.mp3?alt=media&token=95fbe351-6ee2-4148-826a-263a4f10498e ",
    lyrics: ["(chorus)",
  "Predator or the prey, or the prey, or the prey",
  "Predator or the prey, or the prey, or the prey",
  
  "(verse)",
  "When an animal hunts another animal to get its food,",
  "it’s called the predator.",
  "When an animal hunts another animal to get its food,",
  "it’s called the predator.",
  "When an animal is hunted by another animal for food,",
  "it’s called the prey.",
  "When an animal is hunted by another animal for food,",
  "it’s called the prey.",
  
  "(chorus)",
  "Predator or the prey, or the prey, or the prey",
  "Predator or the prey, or the prey, or the prey",
  
  "(verse)",
  "A lion hunts the zebra, the lion is the predator.",
  "The zebra runs fast, it’s the prey, it’s the prey.",
  "An owl swoops down on a little mouse,",
  "The owl is the predator, outside your house!",
  "A fox chase a  rabbit through the grass,",
  "The Rabbit is the prey, trying to dash!",
  "A hawk sees a snake slither on the ground,",
  "Predator and prey, nature’s all around!",
  
  "(chorus)",
  "Predator or the prey, or the prey, or the prey",
  "Predator or the prey, or the prey, or the prey",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "", standardNumber: "3-LS4-3", slug: "",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Environmental Change", standardNumber: "3-LS4-4", slug: "environmentalchange",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fenvironmentalchange2025video.mp4?alt=media&token=ebe3afdd-fb4b-4722-8ae2-f2c469edc617 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fenvironmentalchange2025song.mp3?alt=media&token=7fb064e4-0513-4dea-b929-47ff30f1e3e0 ",
    lyrics: ["(Chorus)",
  "Organisms can thrive in changing environments,",
  "If they adapt or move away, they still might stand a chance.",
  "Organisms can thrive in changing environments,",
  "But some may fail to live if they can't meet new demands.",
  
  "(Verse 1)",
  "Some organisms adapt to their surroundings' shift,",
  "They change their behaviors or grow a special gift.",
  "Adaptation.",
  "But if the change is sudden and the shift is too extreme,",
  "Some might not survive or fulfill their living dreams.",
  "Extinction.",
  "Some migrate to new spaces where conditions suit them more,",
  "While others stay and perish where they were before.",
  "Adaptation.",
  
  "(Bridge)",
  "If the food supply disappears or the water runs dry,",
  "Life can become a struggle, and many might die.",
  "But some species are resilient and can find a new way,",
  "To make a home in places where others couldn’t stay.",
  
  "(Chorus)",
  "Organisms can thrive in changing environments,",
  "If they adapt or move away, they still might stand a chance.",
  "Organisms can thrive in changing environments,",
  "But some may fail to live if they can't meet new demands.",
  
  "(Verse 2)",
  "When climates shift to heat waves or freezing snow and ice,",
  "Some species can evolve, but others pay the price.",
  "Natural Selection.",
  "If pollution fills their waters or habitats are gone,",
  "It creates new challenges to simply carry on.",
  "Survival.",
  "Genetics play a role in how species cope with change,",
  "Some will grow stronger while others fade away.",
  "Natural Selection.",
  
  "(Outro)",
  "Organisms rise or fall depending on their fate,",
  "How they respond to changes can truly resonate.",
  "Adapting or migrating, or even disappearing,",
  "The story of survival is both harsh and endearing.",
  
  "(Chorus)",
  "Organisms can thrive in changing environments,",
  "If they adapt or move away, they still might stand a chance.",
  "Organisms can thrive in changing environments,",
  "But some may fail to live if they can't meet new demands.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Determine Weather", standardNumber: "3-ESS2-1", slug: "determineweather",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fdetermineweather2025video.mp4?alt=media&token=b0dc68f0-f495-4f84-81eb-e9b804dda225 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdetermineweather2025song.mp3?alt=media&token=24b9d787-ecf5-4951-9b5e-3f9be7efc183 ",
    lyrics: ["(Verse)",
  "To determine the weather in a particular time and place,",
  "You should know the temperature, that’s the measure",
  "Of the degree of heat of a substance.",
  
  "To determine the weather in a particular time and place,",
  "Look for precipitation, rain, sleet, snow, hail,",
  "And time period amounts.",
  
  "To determine the weather in a particular time and place,",
  "You should know the wind direction,",
  "Which way is it blowing? North, South, East, or West.",
  
  "To determine the weather in a particular time and place,",
  "You should know the wind speed, the rate of motion of the air",
  "In knots or nautical miles.",
  
  "To determine the weather in a particular time and place,",
  "You should know a barometer is used to measure",
  "The atmospheric pressure.",
  
  "To determine the weather in a particular time and place,",
  "You should know that humidity",
  "Is the amount of water vapor in the air, yeah, yeah, yeah, yeah.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "My Clouds", standardNumber: "3-ESS2-1", slug: "myclouds",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmyclouds2025video.mp4?alt=media&token=b3bfdde1-7ef7-4529-ab91-9ea2d0695053 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmyclouds2025song.mp3?alt=media&token=f47d1541-dc8a-4d3b-868f-90f74543720d ",
    lyrics: ["(Verse)",
  "Cumulus clouds, cumulus clouds, cumulus clouds,",
  "What are they?",
  "Cumulus clouds, cumulus clouds, cumulus clouds,",
  "What are they?",
  "Cumulus clouds mean it's fair weather.",
  "Cumulus clouds, they can form shapes of whatever.",
  "Cumulus clouds are puffy like cotton balls,",
  "And cumulonimbus are darker, and they make thunderstorms.",
  "(Verse)",
  "Stratus clouds, stratus clouds, stratus clouds,",
  "What are they?",
  "Stratus clouds, stratus clouds, stratus clouds,",
  "What are they?",
  "Stratus clouds have layers, and they cover the sky.",
  "Stratus clouds are like a blanket, it makes the sky white.",
  "Stratus clouds become nimbostratus clouds,",
  "When they get thick and dark and make rain or snow.",
  "(Verse)",
  "Cirrus clouds, cirrus clouds, cirrus clouds,",
  "What are they?",
  "Cirrus clouds, cirrus clouds, cirrus clouds,",
  "What are they?",
  "Cirrus clouds look like wild strands of white hair.",
  "Cirrus clouds mean warm moist air is rising over cold air.",
  "Cirrus clouds are made up of ice crystals.",
  "Ice crystals are so thin, the sunlight just passes right on through.",
  "(Chorus)",
  "These are my clouds, these are my clouds, these are my clouds,",
  "I see some days.",
  "These are my clouds, these are my clouds, these are my clouds,",
  "I see some days.",
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Precipitation", standardNumber: "3-ESS2-1", slug: "precipitation",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fprecipitation2025video.mp4?alt=media&token=9be4503a-6378-41d1-be11-38eb8195d5c3 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fprecipitation2025song.mp3?alt=media&token=7cc71098-743b-4545-9391-9b67a7d43062 ",
    lyrics: ["(Chorus)",
  "Precipitation is rain, sleet, snow, and hail.",
  "Precipitation is rain, sleet, snow, and hail.",
  "It’s raining, it’s snowing.",
  "It’s raining, it’s snowing.",
  "It’s sleeting, it’s hailing.",
  "It’s sleeting, it’s hailing.",
  
  "(Verse)",
  "Rain is water droplets falling from the sky.",
  "Snow is white crystal flakes made of ice.",
  "Sleet, small ice pellets that fall from the sky.",
  "Hail, large ice pellets that fall from the sky.",
  
  "(Chorus)",
  "Precipitation is rain, sleet, snow, and hail.",
  "Precipitation is rain, sleet, snow, and hail.",
  "It’s raining, it’s snowing.",
  "It’s raining, it’s snowing.",
  "It’s sleeting, it’s hailing.",
  "It’s sleeting, it’s hailing.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Seasons", standardNumber: "3-ESS2-1", slug: "seasons",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fseasons2025video.mp4?alt=media&token=dd682414-ff8a-4acb-8877-5a488cd7a912 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fseasons2025song.mp3?alt=media&token=04a34ce0-7b3c-4e70-8564-cc5ac75c2bfc ",
    lyrics: ["(chorus)",
  "There is something we have to get clear now,",
  "there are four seasons in every year now.",
  "Do you know the reasons for the seasons? Check this,",
  "seasons come because of the tilt of the Earth's axis.",
  
  "(verse)",
  "We spring ahead in the Spring, then comes the Summer.",
  "Watch the leaves change color, we fall back in Autumn.",
  "Then comes the Winter, which is the coldest season.",
  "The Earth spins on an axis that is tilted, is the reason why this happens.",
  
  "(chorus)",
  "There is something we have to get clear now,",
  "there are four seasons in every year now.",
  "Do you know the reasons for the seasons? Check this,",
  "seasons come because of the tilt of the Earth's axis.",
  
  "(bridge)",
  "Summer, Winter, Spring, Fall.",
  "Summer, Winter, Spring, Fall.",
  "Summer, Winter, Spring, Fall.",
  "Summer, Winter, Spring, Fall.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Fronts", standardNumber: "3-ESS2-1", slug: "fronts",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Storms", standardNumber: "3-ESS2-1", slug: "storms",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fstorms2025song.mp3?alt=media&token=dd2e8260-5e55-4153-801f-7a63a93609cc ",
    lyrics: ["(chorus)",
  "Storms have a difference in air mass",
  "So along fronts is where they happen",
  "The front is the boundary that separates",
  "two different types of air",
  "It could be cold and dry air, warm air, cool air",
  "It could be cold and dry air, warm air, cool air",
  
  "(verse)",
  "When warm air rises and cools fast,",
  "it makes thunderstorms",
  "When warm air rises and cools fast,",
  "it makes thunderstorms",
  "Hurricanes are high winds and heavy rains",
  "Hurricanes are high winds and heavy rains",
  "They form in warm moist air masses",
  "above warm ocean water",
  "Tornadoes also known as twisters",
  "are columns of dark, twisting air, that’s spinning",
  "Tornadoes also known as twisters",
  "are columns of dark, twisting air, that’s spinning",
  
  "(chorus)",
  "Storms have a difference in air mass",
  "So along fronts is where they happen",
  "The front is the boundary that separates",
  "two different types of air",
  "It could be cold and dry air, warm air, cool air",
  "It could be cold and dry air, warm air, cool air",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Hurricanes & Tornadoes", standardNumber: "3-ESS2-1", slug: "hurricanestornadoes",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fhurricanesandtornadoes2025song.mp3?alt=media&token=d9ce0886-c701-44bd-baf1-e9e256c0cdac ",
    lyrics: ["(chorus)",
  "Stormy skies, stormy skies,",
  "Spinning winds and raining highs!",
  "Stormy skies, stormy skies,",
  "Watch the weather dance and rise!",
  
  "(verse 1)",
  "Hurricanes form where the ocean's warm,",
  "Air rises up in a swirling storm.",
  "Winds get strong and the rain pours down,",
  "Spinning and spinning all around!",
  
  "(chorus)",
  "Stormy skies, stormy skies,",
  "Spinning winds and raining highs!",
  "Stormy skies, stormy skies,",
  "Watch the weather dance and rise!",
  
  "(verse 2)",
  "Tornadoes twist when hot meets cold,",
  "Spinning fast, brave and bold!",
  "Thunderstorms boom, lightning strikes,",
  "Tornadoes dance through day and night!",
  
  "(chorus)",
  "Stormy skies, stormy skies,",
  "Spinning winds and raining highs!",
  "Stormy skies, stormy skies,",
  "Watch the weather dance and rise!",
  
  "(bridge)",
  "Hurricanes have an eye that's calm,",
  "But outside winds bring the stormy alarm.",
  "Tornadoes are ranked from E-F-0 to E-F-5,",
  "The higher the number, the faster they drive.",
  "Warm ocean water gives hurricanes their power,",
  "They can last for days — not just an hour!",
  
  "(chorus)",
  "Stormy skies, stormy skies,",
  "Spinning winds and raining highs!",
  "Stormy skies, stormy skies,",
  "Stormy skies up in the skies!",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Climate Zone", standardNumber: "3-ESS2-2", slug: "climatezone",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "", standardNumber: "3-ESS3-1", slug: "",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  

];
export default topics;
